import './styles.scss'

const Agent = ({add='', style={}}) => {
  return (
    <span className='sv2-agent-general-title' style={style}>{`Nelima${add}`}</span>
  )
}

export default Agent